if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Variant updates replace modal children. Never retain a caption from the old photo.
        this.wiMediaObserver = new MutationObserver(() => {
          if (!this.hasAttribute('open')) return;
          const firstMedia = this.querySelector('[role="document"] [data-media-id]');
          this.showActiveMedia(firstMedia?.getAttribute('data-media-id'));
        });
      }

      hide() {
        this.wiMediaObserver.disconnect();
        super.hide();
      }

      disconnectedCallback() {
        this.wiMediaObserver.disconnect();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        const content = this.querySelector('[role="document"]');
        if (content && this.querySelector('[data-wi-active-photo-purpose]')) {
          this.wiMediaObserver.disconnect();
          this.wiMediaObserver.observe(content, { childList: true });
        }
      }

      showActiveMedia(mediaId = this.openedBy?.getAttribute('data-media-id')) {
        const container = this.querySelector('[role="document"]');
        const media = container ? Array.from(container.querySelectorAll('[data-media-id]')) : [];
        const activeMedia = media.find((element) => element.getAttribute('data-media-id') === mediaId) || media[0];
        const caption = this.querySelector('[data-wi-active-photo-purpose]');
        if (caption) {
          const purpose = activeMedia?.getAttribute('data-wi-photo-purpose') || '';
          caption.textContent = purpose;
          caption.hidden = !purpose;
        }
        if (!activeMedia) return;

        media.forEach((element) => element.classList.toggle('active', element === activeMedia));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const mediaWidth = Number(activeMedia.width) || container.clientWidth;
        container.scrollLeft = Math.max(0, (mediaWidth - container.clientWidth) / 2);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
